import { API_URL } from '@constants'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeftIcon } from '@heroicons/react/24/solid'
import ReactMarkdown from 'react-markdown'
import { cmsRehypePlugins } from '../../security/cmsMarkdown'
import { replaceImageExtension } from '@utils'
import { useDetailContent } from '../../hooks/content/useDetailContent'
import { parseBlogDetail } from '../../utils/cmsDetail'
import { ContentStatus } from '../contentStatus/ContentStatus'
import { Helmet } from 'react-helmet-async'

export const BlogDetail = () => {
    const param = useParams()
    const content = useDetailContent(
        param.blogDetailId
            ? `${API_URL}/api/blog-details/${encodeURIComponent(
                  param.blogDetailId
              )}?populate=deep`
            : null,
        parseBlogDetail
    )

    if (content.state !== 'success') {
        return (
            <ContentStatus
                state={content.state}
                emptyMessage="Article introuvable."
            />
        )
    }
    const blogDetail = content.data

    return (
        <>
            <Helmet>
                <title>{`Listen too | article : ${
                    blogDetail?.title ?? 'Article'
                }`}</title>
            </Helmet>
            <section className="bg-white md:px-12  ">
                <div className=" mx-auto md:px-[60px] py-8 lg:gap-8 xl:gap-0 lg:py-16">
                    <div
                        className="text-left flex font-bold"
                        style={{ color: '#00a253' }}
                    >
                        <Link
                            to="/newsroom"
                            aria-label="Retour à la liste des articles"
                            className="focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#0a8335] focus-visible:outline-offset-2 focus-visible:rounded-sm"
                        >
                            <span className="flex text-xs md:text-base hover:underline">
                                <ArrowLeftIcon
                                    aria-hidden={true}
                                    className="mr-1 w-4 font-bold"
                                />
                                Retour
                            </span>
                        </Link>
                    </div>
                    <div
                        className="z-10 flex items-center border rounded-[32px] font-bold mt-12 max-w-[1180px] lg:w-[1180px] relative overflow-hidden md:h-[362px] m-auto"
                        style={{ borderColor: 'white' }}
                    >
                        {blogDetail.image.url && (
                            <img
                                className="z-20  w-full"
                                src={replaceImageExtension(
                                    blogDetail.image.url
                                )}
                                alt={blogDetail.image.alternativeText}
                            />
                        )}
                    </div>
                    <div
                        className="z-30 mt-[-150px] relative border mx-auto rounded-3xl py-12 px-6 md:px-[100px] max-w-[360px] md:max-w-[982px] text-left"
                        style={{
                            backgroundColor: 'white',
                            borderColor: 'white',
                        }}
                    >
                        <h1 className="pt-16 mb-16 text-center text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight leading-none md:text-[52px] md:w-[762px]">
                            {blogDetail?.title}
                        </h1>
                        <p className="mb-8 mt-8 text-sm text-gray-500 md:w-[762px] lg:mb-8 md:text-[16px] flex justify-center">
                            <ReactMarkdown
                                className="text-justify text-sm md:prose"
                                rehypePlugins={cmsRehypePlugins}
                            >
                                {blogDetail.content}
                            </ReactMarkdown>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}
